import { Command } from '../../_base/actionBus/Command';
import { FileData } from '../../infrastructure/uploader/FileData';

export class Upload extends Command<string> {
    constructor(public file: FileData, public onProgress: (number) => void) { super(); }
}
